/**
 * Capitalize each word in a name
 * e.g., "john doe" -> "John Doe"
 */
export function capitalizeName(name: string | null | undefined): string | null {
	if (!name) return null;
	return name
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");
}
